import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function CTASection() {
  const hotArticles = getHotArticles(3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="mb-10 md:mb-14">
          <div className="relative rounded-2xl overflow-hidden aspect-[21/9] md:aspect-[21/7]">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20wide%20panoramic%20scene%20with%20warm%20golden%20amber%20light%20streaks%20on%20dark%20background%2C%20abstract%20luxury%20texture%2C%20mysterious%20elegant%20aesthetic%2C%20film%20grain%20effect%2C%20editorial%20photography%2C%20high%20contrast%2C%20no%20text%20no%20people&width=1600&height=700&seq=cta-banner-911-2026&orientation=landscape"
              alt="深度爆料"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/50"></div>
          </div>
        </div>

        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight mb-4">
            错过今日<span className="text-primary-600 italic">最火爆</span>的瓜？
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            每天都有<strong className="text-foreground-900 font-semibold">新鲜黑料</strong>在这里曝光，
            <em className="text-primary-600 not-italic">第一时间</em>掌握娱乐圈最新动态，
            做朋友圈里<strong className="text-foreground-900 font-semibold">最懂瓜的人</strong>
          </p>
        </div>

        <div className="flex justify-center mb-8 md:mb-10">
          <Link
            to="/category/he-liao-shendu"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-medium hover:bg-foreground-800 transition-all duration-300 hover:scale-105"
          >
            立即进入吃瓜 <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={article.thumbImage}
                  alt={article.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-accent-600 font-medium mb-1">{article.category}</p>
                <h4 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors duration-200">
                  {article.title}
                </h4>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}